import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Bouton retour */}
        <Link
          to="/"
          className="inline-flex items-center text-honey-600 hover:text-honey-700 mb-8"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Retour à l'accueil
        </Link>

        {/* Titre */}
        <h1 className="text-3xl font-bold text-slate-900 mb-8">
          Mentions légales
        </h1>

        {/* Contenu */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          {/* Éditeur du site */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Éditeur du site</h2>
            <div className="bg-slate-50 rounded-lg p-6">
              <h3 className="font-semibold text-slate-800 mb-3">Syndicat Apicole de la Réunion (SAR)</h3>
              <p className="text-slate-600 text-sm mb-4">
                Syndicat régi par la loi du 28 octobre 1982
              </p>
              <ul className="text-slate-600 space-y-2">
                <li>
                  <span className="font-medium">Adresse :</span> 42 rue Alexandre Bègue, 97416 Saint-Leu
                </li>
                <li>
                  <span className="font-medium">SIRET :</span> 490 640 968 00015
                </li>
              </ul>
            </div>
          </section>

          {/* Responsable de publication */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Responsable de la publication</h2>
            <p className="text-slate-600">
              Pascal Faustin
            </p>
          </section>

          {/* Contact */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Contact</h2>
            <ul className="text-slate-600 space-y-2">
              <li>
                <span className="font-medium">Email :</span>{' '}
                <a href="mailto:abeillereunion@gmail.com" className="text-honey-600 hover:underline">
                  abeillereunion@gmail.com
                </a>
              </li>
              <li>
                <span className="font-medium">Téléphone :</span> +262 692 22 28 86
              </li>
            </ul>
          </section>

          {/* Hébergeur */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Hébergeur</h2>
            <div className="bg-slate-50 rounded-lg p-6">
              <p className="font-semibold text-slate-800 mb-2">OVH</p>
              <p className="text-slate-600">
                2 rue Kellermann, 59100 Roubaix – France
              </p>
            </div>
          </section>
        </div>

        {/* Date de mise à jour */}
        <p className="text-sm text-slate-500 mt-6 text-center">
          Dernière mise à jour : Janvier 2026
        </p>
      </div>
    </div>
  );
}
